/**
 * @file 回帖区图片放大镜
 * @author Yangholmes 2024-01-23
 */

import { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import cn from 'classnames';
import CommonIcon from '../CommonIcon';
import CommonReactImage from '@/components/CommontReactImage';

import Styles from './index.module.scss';

const defaultImage = require('@/assets/icon/photo-default-cover.png');

export interface ImageMagnifierProps {
  images: string[];
  initialIndex?: number;
  onClose?: () => void;
}

export const ImageMagnifier: FC<ImageMagnifierProps> = (props) => {
  const {
    images,
    initialIndex = 0,
    onClose
  } = props;

  const [imageList, setImageList] = useState<string[]>(images);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [isWide, setIsWide] = useState(true);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? imageList.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === imageList.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    setImageList(images);
    if (!!images.length && !!images[currentIndex]) {
      const img = new Image();
      img.src = images[currentIndex];
      img.onload = () => {
        setIsWide(img.width >= img.height);
      };
    }
  }, [currentIndex, images])

  const _onClose = () => {
    onClose?.()
  }

  const handleError = () => {
    setImageList((prevImageList) => {
      const updatedList = [...prevImageList];
      updatedList[currentIndex] = defaultImage?.default?.src;
      return updatedList;
    });
  };

  return (!!imageList.length ? createPortal(
    <div className={cn(Styles.root)}>
      <div className={cn(Styles.mask)} onClick={_onClose} />
      <CommonReactImage
        className={Styles.img}
        src={imageList[currentIndex]}
        alt={`Image ${currentIndex + 1}`}
        onError={handleError}
        classNames={{wrapper: Styles.imageWrapper}}
        style={{
          width: isWide ? '100%' : 'auto',
          height: isWide ? 'auto' : '100%',
        }}
      />
      <div className={cn(Styles.close)} onClick={_onClose} />
      {
        imageList.length > 1 && (
          <>
            <button className={cn(Styles.arrowButton)} onClick={handlePrev}>
              <CommonIcon className={Styles.icon} icon="arrow-left" />
            </button>
            <button className={cn(Styles.arrowButton, Styles.right)} onClick={handleNext}>
              <CommonIcon className={Styles.icon} icon="arrow-right" />
            </button>
            <p className={Styles.counter}>{currentIndex + 1} / {imageList.length}</p>
          </>
        )
      }
    </div>,
    document.body
  ) : null)
}
